<template>
    <div class="SchoolDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.Name"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode && CheckPermission(EditPermission)" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddEditSchool()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-school" size="lg" :title="ModalSchoolTitle" hide-footer>
            <b-container v-if="EditMode == false && TargetSchool.Id">
                <b-row>
                    <b-col>
                        <h3>School Info</h3>
                        <p><span class="bold">Name: </span>{{TargetSchool.Name}}</p>
                        <p><span class="bold">Type: </span>{{TargetSchool.SchoolType}}</p>
                    </b-col>
                    <b-col>
                        <h3>Address</h3>
                        <p>{{TargetSchool.Address.AddressLine1}}</p>
                        <p>{{TargetSchool.Address.AddressLine2}}</p>
                        <p>{{TargetSchool.Address.City}}, {{TargetSchool.Address.StateAbbreviation}} {{TargetSchool.Address.ZipCode}}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Phone Number</h3>
                        <p><span class="bold">Main: </span>{{TargetSchool.PhoneNumber.FormattedPhoneNumber}}</p>
                    </b-col>
                    <b-col>
                        <h3>Enrollment Details</h3>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetSchool.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetSchool.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelSchool()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditSchool" autocomplete="off">
                    <b-row v-if="CommonSchools">
                        <b-col>
                            <h3>Pre-Fill with Selected School</h3>
                            <select class="form-control" @change="PrefillSchoolData" v-model="CommonSchoolSelection">
                                <option v-for="(school, index) in CommonSchools" :value="index">{{ school.Name }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>School Info</h3>
                            <div class="form-group">
                                <label>School Name:</label>
                                <input type="text" class="form-control" v-model="TargetSchool.Name" />
                            </div>
                            <div class="form-group">
                                <label>School Type:</label>
                                <select type="text" class="form-control" v-model="TargetSchool.SchoolType">
                                    <option value="Adult School">Adult School</option>
                                    <option value="GED Program">GED Program</option>
                                    <option value="Daycare">Daycare</option>
                                    <option value="Community College">Community College</option>
                                    <option value="Continuation School">Continuation School</option>
                                    <option value="Court School">Court School</option>
                                    <option value="Home School">Home School</option>
                                    <option value="Mainstream Charter">Mainstream Charter</option>
                                    <option value="Mainstream Private">Mainstream Private</option>
                                    <option value="Mainstream Public">Mainstream Public</option>
                                    <option value="Non-Public School">Non-Public School</option>
                                    <option value="Preschool">Preschool</option>
                                    <option value="University">University</option>
                                    <option value="Vocational Program">Vocational Program</option>
                                    <option value="Other">Other</option>
                                    <option value="Not Enrolled">Not Enrolled</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Address</h3>
                            <div class="form-group">
                                <label>Address Line 1:</label>
                                <input type="text" class="form-control" v-model="TargetSchool.Address.AddressLine1" />
                            </div>
                            <div class="form-group">
                                <label>Address Line 2:</label>
                                <input type="text" class="form-control" v-model="TargetSchool.Address.AddressLine2" />
                            </div>
                            <div class="form-group">
                                <label>City:</label>
                                <input type="text" class="form-control" v-model="TargetSchool.Address.City" />
                            </div>
                            <div class="form-group">
                                <label>State:</label>
                                <select class="form-control" v-model="TargetSchool.Address.StateAbbreviation">
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Zip Code:</label>
                                <input type="number" class="form-control" v-model="TargetSchool.Address.ZipCode" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Phone Number</h3>
                            <div class="form-group">
                                <label>Main Phone Number:</label>
                                <input type="text" class="form-control" v-model="TargetSchool.PhoneNumber.PhoneNumberDigits" />
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Enrollment Details</h3>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetSchool.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetSchool.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelSchool()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteSchool()" type="button" v-if="TargetSchool.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "GetEndpoint",//string
            "GetPayload",//object
            "AddEditEndpoint",//string
            "AddEditPayload",//object
            "DeleteEndpoint",//string
            "DeletePayload",//object
            "CommonSchools",//object, nullable
            "EditPermission"
        ],
        data: function () {
            return {
                TargetSchool: {},
                CommonSchoolSelection: "",
                ModalSchoolTitle: "",
                LoadedRecords: [],//Contact Membership Records
                SchoolSchema: {
                    StartDate: "",
                    EndDate: "",
                    Name: "",
                    SchoolType: "",
                    Address: {
                        AddressLine1: "",
                        AddressLine2: "",
                        City: "",
                        StateAbbreviation: "",
                        ZipCode: ""
                    },
                    PhoneNumber: {
                        PhoneNumberDigits: ""
                    }
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetSchools() {
                this.$MasterAPI.ExecuteRequest("GET", this.GetEndpoint, this.GetPayload, this.GetSchoolsSuccess, () => { },false)
            },
            GetSchoolsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(school) {
                this.TargetSchool = JSON.parse(JSON.stringify(school));
                
                if (this.EditMode) {
                    this.ModalSchoolTitle = "Editing " + school.Name;
                } else {
                    this.ModalSchoolTitle = "Viewing " + school.Name;
                }
                this.$refs["modal-school"].show();
            },
            ShowAddEditSchool() {
                this.TargetSchool = JSON.parse(JSON.stringify(this.SchoolSchema));
                this.ModalSchoolTitle = "Add New School";
                this.CommonSchoolSelection = "";
                this.$refs["modal-school"].show();
            },
            AddEditSchool(e) {
                e.preventDefault();
                //get person data here
                this.$MasterAPI.ExecuteRequest("POST", this.AddEditEndpoint, { ...this.TargetSchool, ...this.AddEditPayload }, this.AddEditSchoolSuccess, () => { }, true);
            },
            AddEditSchoolSuccess(response) {
                this.GetSchools();
                this.$refs["modal-school"].hide();
            },
            DeleteSchool() {
                this.$MasterAPI.ExecuteRequest("POST", this.DeleteEndpoint, { Id: this.TargetSchool.Id }, this.DeleteSchoolSuccess, () => { }, true);
            },
            DeleteSchoolSuccess(response) {
                this.GetSchools();
                this.$refs["modal-school"].hide();
            },
            CancelSchool() {
                this.$refs['modal-school'].hide();
            },
            PrefillSchoolData() {
                this.TargetSchool = this.CommonSchools[this.CommonSchoolSelection];
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    },
                    {
                        name: "Address.City",
                        title: "LOCATION"
                    },
                    {
                        name: "SchoolType",
                        title: "TYPE"
                    },
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY',
                    },
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                ];
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
        },
        mounted() {
            this.GetSchools();
            this.TargetSchool = this.SchoolSchema;
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>